/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/
// Core
import styled from 'styled-components';

// Plugins
import { hexToRgba } from '../../plugins/general';

export const Container = styled.div`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.color.machineCard.borderColor};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 66px;
  padding: 16px;
  width: 100%;

  &:hover {
    border: 1px solid ${({ theme }) => theme.color.machineCard.hoverBorderColor};
    box-shadow: 2px 2px 6px ${({
      theme,
    }) => hexToRgba(theme.color.machineCard.hoverShadowColor, 0.5)};
  };
`;

export const IconContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.machineCard.iconBackgroundColor};
  border-radius: 4px;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;

  > svg {
    width: 16px;
    height: 16px;
  };
`;

export const DescriptionContainer = styled.div`
  margin-left: 16px;
  max-width: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  min-width: 0;
`;
